export default __webpack_public_path__ + "static/media/signature.5c0bc22d.svg";